<template>
    <div class="row all-users-table">
        <div class="row mb-5">
            <div class="col-12">
                <button
                    class="btn filter-btn"
                    @click="
                        filterType = 'active';
                        getResults();
                    "
                    :class="filterType == 'active' ? 'active' : ''"
                >
                    All Active
                </button>
                <button
                    class="btn filter-btn"
                    @click="
                        filterType = 'pending';
                        getResults();
                    "
                    :class="filterType == 'pending' ? 'active' : ''"
                >
                    All Pending
                </button>
                <button
                    class="btn filter-btn"
                    @click="
                        filterType = 'd2d-active';
                        getResults();
                    "
                    :class="filterType == 'd2d-active' ? 'active' : ''"
                >
                    D2D Active
                </button>
                <button
                    class="btn filter-btn"
                    @click="
                        filterType = 'denied';
                        getResults();
                    "
                    :class="filterType == 'denied' ? 'active' : ''"
                >
                    Denied
                </button>
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-sm-12 col-md-12 text-right top-area">
                    <Bootstrap4Pagination
                        :data="paginatedAllUsers"
                        @pagination-change-page="getResults"
                        :align="'right'"
                    >
                        <template #prev-nav>
                            <i class="fa fa-arrow-left"></i> PREVIOUS</template
                        >
                        <template #next-nav>
                            NEXT <i class="fa fa-arrow-right"></i>
                        </template>
                    </Bootstrap4Pagination>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-5">
                    <div
                        class="d-flex align-items-center justify-content-between pb-2"
                    >
                        <h3 class="mb-0">All Users</h3>
                        <!-- <div style="display: flex; gap: 22px; align-items: end">
                            <div v-if="d2dData != null" class="d2d-report">
                                <div class="d2d-report-title">
                                    DIRECT TO DEALER
                                </div>
                                <div class="d2d-report-data">
                                    <div>
                                        <div>ENROLLED:</div>
                                        <div>
                                            {{ d2dData.enrolled }}
                                        </div>
                                    </div>
                                    <div>
                                        <div>NOT ENROLLED:</div>
                                        <div>
                                            {{ d2dData.not_enrolled }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span
                                v-if="['super_admin','sales_admin'].includes(user.role.name)"
                                class="add-button btn btn-action"
                                @click="openModal(null, 'add', 'self')"
                            >
                                <i
                                    class="fa fa-plus-circle"
                                    aria-hidden="true"
                                ></i>
                                ADD USER
                            </span>

                            <div class="form-group">
                                <div class="input-group search-field">
                                    <input
                                        class="form-control"
                                        type="text"
                                        @input="handleSearch()"
                                        placeholder="Search Users"
                                        v-model="searchTerm"
                                        autocomplete="off"
                                    />
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"
                                            ><i class="fas fa-search"></i
                                        ></span>
                                    </div>
                                </div>
                        </div> -->
                    </div>
                </div>
                <div class="col-sm-12 col-md-3 text-right">
                    <span
                        v-if="['super_admin','sales_admin','sales_reps'].includes(authUser.role.name)"
                        class="add-button btn btn-action"
                        @click="openModal(null, 'add', 'self')"
                    >
                        <i
                            class="fa fa-plus-circle"
                            aria-hidden="true"
                        ></i>
                        ADD USER
                    </span>
                </div>
                <div class="col-sm-12 col-md-4 text-right">
                    <div class="form-group">
                        <div class="input-group search-field">
                            <input
                                class="form-control"
                                type="text"
                                @input="handleSearch()"
                                placeholder="Search Users"
                                v-model="searchTerm"
                                autocomplete="off"
                            />
                            <div class="input-group-prepend">
                                <span class="input-group-text"
                                    ><i class="fas fa-search"></i
                                ></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-4 text-right"></div>
                
            </div>
            <table
                class="table table-responsive table-striped border-bottom mt-2"
            >
                <thead class="thead-light">
                    <tr>
                        <th>Company Name</th>
                        <th>Role</th>
                        <th>Company Email</th>
                        <th>Address</th>
                        <th>City</th>
                        <th>State</th>
                        <th>Zip Code</th>
                        <th>Status</th>
                        <th>Last Login Date</th>
                        <th>Direct to Dealer</th>
                        <th style="width: 18em"></th>
                    </tr>
                </thead>
                <tbody>
                    <template
                        v-for="user in paginatedAllUsers.data"
                        :key="user.id"
                    >
                        <tr>
                            <td>{{ user.name }}</td>
                            <td>{{ user.role.display_name }}</td>
                            <td>{{ user.email }}</td>
                            <td>{{ user.address }}</td>
                            <td>{{ user.city }}</td>
                            <td>{{ user.state }}</td>
                            <td>{{ user.zip_code }}</td>
                            <td>
                                <span class="td-user-status"
                                    :class="user.status_text"
                                >{{ user.status_text }}</span>
                            </td>
                            <td>{{ user.last_login_data }}</td>
                            <td>
                                <!-- <template
                                    v-if="
                                        user.first_location?.location?.direct_to_dealer_onboarding?.document_file_path != null || 
                                        user.first_location?.location?.direct_to_dealer_onboarding?.onboarding_status == 'active'
                                    "
                                    >Yes</template
                                >
                                <template
                                    v-else-if="
                                        user.first_location?.location?.direct_to_dealer_onboarding?.onboarding_status == 'pending'
                                    "
                                    >Pending</template
                                >
                                <template v-else>No</template> -->
                                <template
                                    v-if="user.is_d2c_enabled === 0"
                                    >Disabled</template
                                >
                                <template
                                    v-else-if="
                                        user.first_location?.location
                                            ?.direct_to_dealer_onboarding
                                            ?.document_file_path != null
                                    "
                                    >Yes</template
                                >
                                <template
                                    v-else-if="
                                        user.first_location?.location
                                            ?.direct_to_dealer_onboarding
                                            ?.onboarding_status == 'pending'
                                    "
                                    >Pending</template
                                >
                                <template v-else>No</template>
                            </td>
                            <td>
                                <span
                                    class="px-2 view-action"
                                    @click="viewUser(user)"
                                    ><i
                                        class="fa fa-eye"
                                        aria-hidden="true"
                                    ></i>
                                    VIEW</span
                                >
                                <span class="px-2 view-action">
                                    <a
                                        :href="
                                            'impersonate/take/' +
                                            user.id +
                                            '/web'
                                        "
                                        class="view-action text-decoration-none"
                                        target="_self"
                                        @click="clearStorage"
                                    >
                                        <i
                                            class="fa fa-sign-in"
                                            aria-hidden="true"
                                        ></i>
                                        IMPERSONATE
                                    </a>
                                </span>
                                <br/>
                                <lock-unlock-button
                                  :user="user"
                                  :current-user="authUser"
                                  @success="handleLockUnlockSuccess"
                                />
                                <ForcePasswordResetButton
                                  v-if="!user.is_password_force_reset"
                                  :user="user"
                                  :current-user="authUser"
                                  @success="handleLockUnlockSuccess"
                                />
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>

            <Bootstrap4Pagination
                :data="paginatedAllUsers"
                @pagination-change-page="getResults"
                :align="'right'"
                :limit="1"
                :keepLength="true"
            >
                <template #prev-nav>
                    <i class="fa fa-arrow-left"></i> PREVIOUS</template
                >
                <template #next-nav>
                    NEXT <i class="fa fa-arrow-right"></i>
                </template>
            </Bootstrap4Pagination>

            <!-- Pagination -->
            <!-- <table-pagination
                v-model="paginatedAllUsers"
                :all-rows="searchAllUsersbyTerm"
                :perPage="perPage"
                @updateRow="updateRow"
            >
            </table-pagination> -->
        </div>

        <!-- Add sub user modal -->
        <b-modal
            v-model="modalShow"
            :title="modalType == 'add' ? 'ADD USER' : 'EDIT USER'"
            hide-footer
        >
            <UserModal
                v-if="modalShow"
                :modal-data="modalData"
                :modal-type="modalType"
                :modal-set="modalSet"
                @close-modal="closeModal"
            />
        </b-modal>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

import TablePagination from "@/components/TablePagination.vue";
import UserModal from "@/components/modals/UserModal.vue";
import { Bootstrap4Pagination } from "laravel-vue-pagination";
import LockUnlockButton from "@/components/LockUnlockButton.vue"
import ForcePasswordResetButton from "../ForcePasswordResetButton.vue";

export default {
    props: [],
    emits: [],
    components: {
        TablePagination,
        UserModal,
        Bootstrap4Pagination,
        LockUnlockButton,
        ForcePasswordResetButton
    },
    setup() {
        const store = useStore();

        let authUser = computed(function () {
            return store.state.user;
        });
        let allUsers = computed(function () {
            return store.state.allUsers;
        });

        function activateUser(id) {
            store.dispatch("activateUser", id);
        }

        function setUserInfo(order) {
            store.commit("setUserInfo", order);
        }

        //onMounted(() => {
        //    store.dispatch("getAllUsers");
        //});

        return {
            authUser,
            allUsers,
            activateUser,
            setUserInfo,
        };
    },
    data() {
        return {
            paginatedAllUsers: [],
            perPage: 100,
            isLoading: false,
            searchTerm: "",
            modalShow: false,
            modalType: null,
            modalSet: null,
            modalData: {},
            d2dData: null,
            currentPage: 1,
            debouncedFunction: null,
            filterType: "active",
        };
    },
    computed: {
        searchAllUsersbyTerm() {
            if (this.searchTerm === "") {
                return this.allUsers;
            }

            return this.allUsers.filter((user) => {
                if (
                    (user.name !== null &&
                        user.name
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase())) ||
                    (user.first_name !== null &&
                        user.first_name
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase())) ||
                    (user.last_name !== null &&
                        user.last_name
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase())) ||
                    (user.address !== null &&
                        user.address
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase())) ||
                    (user.city !== null &&
                        user.city
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase())) ||
                    (user.state !== null &&
                        user.state
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase())) ||
                    (user.zip_code !== null &&
                        user.zip_code
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase())) ||
                    (user.role?.display_name !== null &&
                        user.role?.display_name
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase()))
                ) {
                    return user;
                }
            });
        },
    },
    mounted() {
        this.getD2DReport();
        this.getResults();
    },
    methods: {
        updateRow(val) {
            this.paginatedAllUsers = val;
        },
        updateStatus(userid) {
            this.loader = this.$loading.show();
            this.activateUser(userid);
            this.loader.hide();
        },
        viewUser(user) {
            this.setUserInfo(user);
            this.$router.push({ name: "userInfo", params: { id: user.id } });
        },
        openModal(data, val, set) {
            this.modalType = val;
            this.modalSet = set;
            this.modalData = data;
            this.modalShow = !this.modalShow;
        },
        closeModal() {
            this.modalShow = !this.modalShow;
            this.getResults();
        },
        clearStorage() {
            localStorage.setItem("orders", JSON.stringify([]));
        },
        getD2DReport() {
            axios
                .get("/api/d2d-report", {})
                .then((res) => {
                    this.d2dData = res.data;
                })
                .catch((err) => {});
        },
        getResults(page = 1) {
            let searchTerm = this.searchTerm;
            axios
                .get(
                    "/api/get-all-users-paginated?page=" +
                        page +
                        "&search=" +
                        searchTerm +
                        "&filterType=" +
                        this.filterType
                )
                .then((res) => {
                    this.paginatedAllUsers = res.data;
                })
                .catch((err) => {});
        },

        handleSearch() {
            if (this.debouncedFunction) {
                clearTimeout(this.debouncedFunction);
            }
            this.debouncedFunction = setTimeout(() => {
                this.getResults(1);
            }, 500);
        },

        handleLockUnlockSuccess(user) {
          this.getResults(this.currentPage);
        }
    },
};
</script>
<style scoped>
.d2d-report {
    /* border: 2px solid #d8312a; */
    border: 2px solid #FF7F00;
    width: 230px;
}
.d2d-report-title {
    /* background: #d8312a; */
    background-color: #FF7F00;
    color: white;
    font-weight: 600;
    padding: 8px;
    font-family: "TT-Norms-ExtraBold";
    text-align: center;
}
.d2d-report-data {
    padding: 5px;
    font-family: "TT-Norms-ExtraBold";
    color: black;
    font-size: 14px;
}

.d2d-report-data > div {
    display: flex;
    justify-content: space-between;
}

/* .filter-btn {
    font-weight: 600;
    background-color: #e1e1e1;
    margin-right: 5px;
    font-weight: 700;
    font-family: "TT-Norms-ExtraBold";
}

.filter-btn.active {
    font-weight: 600;
    background-color: #d8312a;
    margin-right: 5px;
    color: white;
} */
</style>
